import { render, staticRenderFns } from "./ClientSetupWizard.vue?vue&type=template&id=b648701c&scoped=true"
import script from "./ClientSetupWizard.vue?vue&type=script&lang=js"
export * from "./ClientSetupWizard.vue?vue&type=script&lang=js"
import style0 from "./ClientSetupWizard.vue?vue&type=style&index=0&id=b648701c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b648701c",
  null
  
)

export default component.exports